import React, {useState, useEffect} from 'react'
// Styles
import './cmif.style.css'
// Images
import NH_Logo from '../../assets/images/logo/nh-logo.png'
// Components
import Copyright from '../../components/Copyright'
// Action
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
import { DecryptedOBJ, DecryptedText } from '../../utils/Encryption'

function Card_MoreInfo() {
    const [loading, setLoading] = useState(true);
    const [pageDetail, setPageDetail] = useState({
        title: '',
        detail: ''
    });

    useEffect(() => {
        dataInit();
    }, []);

    const dataInit = async() => {
        await getInfoDetailInit();
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ (API) ~~~~~~~~~~~~~~~~~~~~~~ //
    const getInfoDetailInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetInfoDetail()
            .then(res => {
                if(res.isSuccess === true)
                {
                    setLoading(false);
                    setPageDetail({
                        title: res.info.Title,
                        detail: res.info.Detail
                    });
                }
            })
        })
    }
    
    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="cmif-container">
                {/* header banner */}
                <div className="logo">
                    <img src={NH_Logo} />
                </div>
                {/* header text */}
                <h1 className="header-text">{pageDetail.title}</h1>
    
                {/* order condition */}
                <div dangerouslySetInnerHTML={{__html: pageDetail.detail}}></div>

                {/* <div className="card">
                    <div className="order-condi-wrap">
                        <label>เงื่อนไขการใช้สั่งซื้อ</label>
                        <ul>
                            <li>
                                <span className="md-dot">•</span> <span>สามารถซื้อแพ็กเกจและชำระเงินได้ภายในวันที่ 1-12 ก.ค. 65 เท่านั้น</span>
                            </li>
                            <li>
                                <span className="md-dot">•</span> <span>สามารถรับบริการได้ตั้งแต่วันที่ 1 ก.ค.- 30 ก.ย.65</span> 
                            </li>
                            <li>
                                <span className="md-dot">•</span> <span>สามารถรับบริการได้ที่ Lab Center N Health ทุกสาขา</span> 
                            </li>
                        </ul>
                    </div> */}
    
                    {/* service condition */}
                    {/* <div className="order-condi-wrap"></div>
                        <label>เงื่อนไขการใช้บริการ</label>
                        <ul>
                            <li>
                                <span className="md-dot">1.</span>
                                <span>เพื่อให้ท่านได้รับบริการที่สะดวกรวดเร็ว กรุณานัดหมายล่วงหน้า 1 วัน</span> 
                            </li>
                            <li>
                                <span className="md-dot">2.</span> 
                                <span>กรณีที่ท่านไม่ได้ทำการนัดหมายล่วงหน้าเจ้าหน้าที่ขอตรวจสอบข้อมูลการชำระเงินโดยท่านต้องแสดงหลักฐานใบเสร็จรับเงินกับเจ้าหน้าที่</span> 
                            </li>
                            <li>
                                <span className="md-dot">3.</span> 
                                <span>หากท่านไม่ได้เป็นผู้เข้ารับการตรวจสุขภาพเองขอให้ผู้ที่เข้ารับบริการแทนแสดง หลักฐานใบเสร็จของท่านเพื่อรับบริการ</span> 
                            </li>
                            <li>
                                <span className="md-dot">4.</span> 
                                <span>แพ็กเกจที่ท่านได้สั่งซื้อและชำระเงินแล้ว ไม่สามารถแลก เปลี่ยน หรือคืนเป็นเงินสดได้</span> 
                            </li>
                            <li>
                                <span className="md-dot">5.</span> 
                                <span>ทางบริษัทขอสงวนสิทธิการเข้ารับบริการหากท่านไม่ปฏิบัติตามเงื่อนไขที่บริษัทกำหนด</span> 
                            </li>
                        </ul>
                    </div>
                </div> */}
                {/* Copyright */}
                <Copyright position={'fixed'} bgColor={'white'}/>
            </div>
        )
    }
}

export default Card_MoreInfo